var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlutonicName = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 37,
    viewBox: "0 0 215 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.64 4.45508C118.963 4.45508 111.857 11.502 111.857 20.2378C111.857 28.9736 118.904 36.0205 127.64 36.0205C136.318 36.0205 143.423 28.9736 143.423 20.2378C143.423 11.502 136.318 4.45508 127.64 4.45508ZM127.64 30.0802C122.224 30.0802 117.798 25.654 117.798 20.2378C117.798 14.8216 122.224 10.3954 127.64 10.3954C133.056 10.3954 137.483 14.8216 137.483 20.2378C137.483 25.7122 133.056 30.0802 127.64 30.0802Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.905 10.3954H215V4.45508H206.905C198.227 4.45508 191.122 11.502 191.122 20.2378C191.122 28.9736 198.169 36.0205 206.905 36.0205H215V30.0802H206.905C201.489 30.0802 197.063 25.654 197.063 20.2378C197.063 14.8216 201.489 10.3954 206.905 10.3954Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3117 24.1387C78.3117 27.4001 75.6327 30.0791 72.3713 30.0791C69.1099 30.0791 66.4309 27.4001 66.4309 24.1387V4.10458H60.4906V24.1387C60.4906 30.6615 65.7903 35.9612 72.3131 35.9612C78.8358 35.9612 84.1356 30.6615 84.1356 24.1387V4.10458H78.1952V24.1387H78.3117Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.245 5.0957C154.722 5.0957 149.423 10.3955 149.423 16.9182V36.9523H155.363V16.9182C155.363 13.6568 158.042 10.9778 161.303 10.9778C164.565 10.9778 167.244 13.6568 167.244 16.9182V36.9523H173.184V16.9182C173.126 10.3955 167.768 5.0957 161.245 5.0957Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.12 3.46396H179.18V36.9513H185.12V3.46396Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6623 10.3954H96.5444V36.9523H102.485V10.3954H108.367V4.45508H90.6623V10.3954Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7769 24.1387V3.46396H37.8365V24.1387C37.8365 30.6615 43.1363 35.9612 49.659 35.9612H53.5028V30.0791H49.659C46.4559 30.0791 43.7769 27.4001 43.7769 24.1387Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2891 0.551758C7.61147 0.551758 0.506348 7.59868 0.506348 16.3345V37.0093H6.44668V28.6229C9.12567 30.7777 12.5618 32.1172 16.2891 32.1172C24.9666 32.1172 32.0718 25.0703 32.0718 16.3345C32.0718 7.59868 25.0249 0.551758 16.2891 0.551758ZM16.2891 26.1768C10.8728 26.1768 6.44668 21.7507 6.44668 16.3345C6.44668 10.9183 10.8728 6.49212 16.2891 6.49212C21.7053 6.49212 26.1314 10.9183 26.1314 16.3345C26.1897 21.7507 21.7635 26.1768 16.2891 26.1768Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlutonicName);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plutonicName.356a2e8472dabfcbf0f30ebc618b616b.svg";